import React, { useState } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import LandingPage from './pages/LandingPage'
import PrivacyPolicy from './pages/PrivacyPolicy'
import TermsOfService from './pages/TermsOfService'
import PricingPage from './pages/PricingPage'
import ThankYou from './pages/ThankYou'
import VibeCodePage from './pages/VibeCodePage'
import ScrollToTop from './components/ScrollToTop'
import GATracker from './components/GATracker'
import EmailCaptureModal from './components/EmailCaptureModal'
import FloatingButtons from './components/FloatingButtons'
import CookieConsent from './components/CookieConsent'

function App() {
  const [bannerVisible, setBannerVisible] = useState(false)

  return (
    <Router>
      <ScrollToTop />
      <GATracker />
      <EmailCaptureModal />
      <FloatingButtons bannerVisible={bannerVisible} />
      <CookieConsent onVisibilityChange={setBannerVisible} />
      <div className="min-h-screen">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/vibe-code" element={<VibeCodePage />} />
        </Routes>
      </div>
    </Router>
  )
}

export default App

